import { render, staticRenderFns } from "./TimeAttendence.vue?vue&type=template&id=2bbd1978"
import script from "./TimeAttendence.vue?vue&type=script&lang=js"
export * from "./TimeAttendence.vue?vue&type=script&lang=js"
import style0 from "./TimeAttendence.vue?vue&type=style&index=0&id=2bbd1978&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports